<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="10">
                    <h3>{{ this.$route.name }}</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
              <b-col md="1" sm="12">
                <b-form-group label="Nº:">
                    <b-form-input type="number" id="numCadastro" :disabled="true" v-model="questionario.id"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col offset-md="1" md="4" sm="12">
                <b-form-group label="Titulo:">
                    <b-form-input type="text" id="titulo" :disabled="true" v-model="questionario.titulo"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col offset-md="3" sm="3">
                <b-button v-if="can('questionario.showAnswer')" @click="visualizarEnvios" block variant="primary" style="margin-top: 27px; widht: 80%">
                  <span>Visualizar Destinatários</span>
                </b-button>
            </b-col>
            </b-row>
            <b-row>
              <b-col md="8" sm="12">
                  <b-form-group label="Filtro:">
                      <b-form-input type="text" placeholder="ID, Nome da organização, Responsável pelo preenchimento ou e-mail" v-model="filtros.filter"></b-form-input>
                  </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2" sm="12">
                <b-form-group label="Data da Resposta:">
                  <b-input-group>
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class='fa fa-calendar'> </i></span>
                    </div>
                    <b-form-input id="type-date" type="date" v-model="filtros.data"> </b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>        
              <b-col md="3" sm="12">
                <b-form-group>
                  <b-form-group label="Situação:">
                    <b-form-select v-model="filtros.situacao" id="checkbox-group-2" :options="situacoes"></b-form-select>
                  </b-form-group>
                </b-form-group>
              </b-col>
              <b-col md="3" sm="12">
                <b-form-group>
                  <b-form-group label="Tipo Envio:">
                    <b-form-select v-model="filtros.tipoEnvio" id="checkbox-group-2" :options="tipoEnvio"></b-form-select>
                  </b-form-group>
              </b-form-group>
            </b-col>
            </b-row>
            <br>
            <br>
            <b-row> 
              <b-col sm="8">
                <b-alert show variant="secondary" md="2" sm="12">
                <h6 class="alert-heading"><b>Exportar Respostas  </b><i class='fa fa-info-circle' v-b-tooltip.hover title="Filtros utilizados para exportar respostas."></i></h6>
                  <b-row>
                    <b-col md="4" sm="12">
                      <b-form-group label="Data da Resposta Início:">
                        <b-input-group>
                          <div class="input-group-prepend">
                            <span class="input-group-text"><i class='fa fa-calendar'> </i></span>
                          </div>
                          <b-form-input :state="chkState('dataInicio')" id="type-date" type="date" v-model="filtros.dataInicio"> </b-form-input>
                        <b-form-invalid-feedback id="input1LiveFeedback5">O campo Data da Resposta Início é obrigatório.</b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                      <b-form-group label="Data da Resposta Fim:">
                        <b-input-group>
                          <div class="input-group-prepend">
                            <span class="input-group-text"><i class='fa fa-calendar'> </i></span>
                          </div>
                          <b-form-input :state="chkState('dataFim')" id="type-date" type="date" v-model="filtros.dataFim"> </b-form-input>
                        <b-form-invalid-feedback id="input1LiveFeedback5">O campo Data da Resposta Fim é obrigatório.</b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-alert>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="2">
                <b-button @click="resetForm()" block>
                    <span>Limpar Filtros</span>
                </b-button>
              </b-col>              
            <b-row>
            </b-row>
              <b-col offset-md="10"  md="2">
                <b-button @click="exportarRespostas" block variant="primary" style="margin-top: 27px;">
                    <span>Exportar Respostas</span>
                </b-button>
            </b-col>
        </b-row>
        </b-card-body>
  
        <b-row>
          <b-col sm="12">
            <b-col sm="12">
              <b-table
                striped
                hover
                bordered
                small
                responsive
                :items="respostas"
                filter
                :current-page="pagina"
                :fields="fields"
                per-page="20"
                :show-empty="true"
                empty-text="Não há respostas para o formulário..."
              >

                <template v-slot:cell(id)="row">
                  {{ row.item.id ? row.item.id : ' - '}}
                </template>

                <template v-slot:cell(nome_organizacao)="row">
                  {{ row.item.nome_organizacao ? row.item.nome_organizacao : ' - '}}
                </template>

                <template v-slot:cell(nome_responsavel)="row">
                  {{ row.item.nome_responsavel ? row.item.nome_responsavel : ' - '}}
                </template>

                <template v-slot:cell(email)="row">
                  {{ row.item.email ? row.item.email : ' - '}}
                </template>

                <template v-slot:cell(created_at)="row">
                  {{ row.item.updated_at ? format_date(row.item.updated_at) : format_date(row.item.created_at) }}
                </template>

                <template v-slot:cell(situacao)="row">
                  {{ row.item.link ? 'Respondida' :
                        row.item.status === 'RE' ? 'Reenviada' :
                          row.item.status === 'RP' ? 'Respondida' : 'N/A'}}
                </template>

                <template v-slot:cell(actions)="row">
                  <b-button size="sm" class="mr-1" title="Visualizar Resposta" @click="visualizarResposta(row.item.idResposta)">
                    <i class="fa fa-search"/>
                  </b-button>
                  <b-button size="sm" class="mr-1" title="Download de Arquivos" @click="downloadArquivos(row.item.idResposta)">
                    <i class="fa fa-folder"/>
                  </b-button>
                  <b-button v-if="row.item.email" size="sm" variant="primary" title="Reencaminhar" @click="reencaminhar(row.item.questionario_enviado_id)" class="mr-1">
                    <i class="fa fa-paper-plane"/>
                  </b-button>
                </template>

                <template v-slot:cell(tipoEnvio)="row">
                  <p>{{row.item.email ? 'E-mail' : 'Link'}}</p>
                </template>
              </b-table>

              <label> Exibindo página {{ pagina }} de {{ totalDePaginas }}, total de {{ respostas.length }} registros.</label>

              <b-pagination
                v-model="pagina"
                :total-rows="respostas.length"
                per-page="20"
                size="sm"
                align="left"
              ></b-pagination>

            </b-col>
          </b-col>
        </b-row>
        <b-card-footer>
          <b-col md="3">
            <b-button block variant="secondary" @click="voltar()">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-card-footer>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import SessionStorage from '@/services/session-storage'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

miniToastr.init()

export default {
  name: 'RespostasQuestionario',
  components: {
    Pagination,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    filtros: {
      dataInicio: {
        required
      },
      dataFim: {
        required
      }
    }
  },
  created () {
    this.$store.dispatch('getPerfis')
    this.$store.dispatch('getQuestionario', this.$route.params.id)
    this.$store.dispatch('getRespostas', {id: this.$route.params.id})
    this.buscaUsuarioIntegracao()
  },
  data () {
    return {
      exportar: false,
      modalControl: false,
      modalTipo: '',
      titulo_descricao: '',
      idAlterar: '',
      titulo_botao: '',
      situacoes: [
        { value: '', text: 'Selecione' },
        { value: 'RE', text: 'Reenviada' },
        { value: 'RP', text: 'Respondida' }
      ],
      tipoEnvio: [
        { value: '', text: 'Selecione' },
        { value: 'email', text: 'E-mail' },
        { value: 'link', text: 'Link' }
      ],
      filtros: {
        filter: '',
        data: '',
        situacao: '',
        tipoEnvio: '',
        dataInicio: '',
        dataFim: ''
      },
      pagina: 1,
      fields: [
        { key: 'id',
          label: 'ID'},
        { key: 'nome_organizacao',
          label: 'Nome da Organização'},
        { key: 'nome_responsavel',
          label: 'Responsável pelo Preenchimento'},
        { key: 'email',
          label: 'E-mail'},
        { key: 'created_at',
          label: 'Data da Resposta',
          thStyle: {
            width: '10%',
            'text-align': 'center'
          },
          tdClass: 'text-center'},
        { key: 'situacao',
          label: 'Situação',
          thStyle: {
            width: '10%',
            'text-align': 'center'
          },
          tdClass: 'text-center'},
        { key: 'tipoEnvio',
          label: 'Tipo de Envio',
          thStyle: {
            width: '10%',
            'text-align': 'center'
          },
          tdClass: 'text-center'},
        { key: 'actions',
          label: 'Ações',
          thStyle: {
            width: '10%',
            'text-align': 'center'
          },
          tdClass: 'text-center'}
      ]
    }
  },
  computed: {
    perfilAtual () {
      return this.$store.state.questionario.perfilAtual
    },
    respostas () {
      return this.$store.state.resposta.respostas
    },
    totalDePaginas () {
      let total = 0
      let calc = 0

      calc = (this.respostas.length / 20)

      if (calc % 1 !== 0) {
        total = parseInt(calc + 1)
      }

      return total
    },
    questionario () {
      return this.$store.state.questionario.questionarioEditar
    },
    perfis () {
      return this.$store.state.perfil.lista
    },
    isValid () {
      return !this.$v.filtros.$anyError
    }
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRespostas',
        {id: this.$route.params.id,
          filter: this.filtros.filter,
          data: this.filtros.data,
          situacao: this.filtros.situacao,
          tipoEnvio: this.filtros.tipoEnvio})
    },
    'filtros.data': function () {
      this.$store.dispatch('getRespostas',
        {id: this.$route.params.id,
          filter: this.filtros.filter,
          data: this.filtros.data,
          situacao: this.filtros.situacao,
          tipoEnvio: this.filtros.tipoEnvio})
    },
    'filtros.situacao': function () {
      this.$store.dispatch('getRespostas',
        {id: this.$route.params.id,
          filter: this.filtros.filter,
          data: this.filtros.data,
          situacao: this.filtros.situacao,
          tipoEnvio: this.filtros.tipoEnvio})
    },
    'filtros.tipoEnvio': function () {
      this.$store.dispatch('getRespostas',
        {id: this.$route.params.id,
          filter: this.filtros.filter,
          data: this.filtros.data,
          situacao: this.filtros.situacao,
          tipoEnvio: this.filtros.tipoEnvio})
    }
  },
  methods: {
    pesquisar () {
      this.$store.dispatch('getRespostas',
        {id: this.$route.params.id,
          filter: this.filtros.filter,
          data: this.filtros.data,
          situacao: this.filtros.situacao,
          tipoEnvio: this.filtros.tipoEnvio})
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    resetForm () {
      this.filtros.filter = ''
      this.filtros.data = ''
      this.filtros.situacao = ''
      this.filtros.tipoEnvio = ''
      this.filtros.dataInicio = ''
      this.filtros.dataFim = ''
      this.$nextTick(() => { this.$v.$reset() })
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    visualizarResposta (id) {
      this.$router.push('/resposta/visualizar/' + id)
    },
    visualizarEnvios () {
      this.$router.push('/destinatarios/' + this.$route.params.id)
    },
    reencaminhar (id) {
      this.$router.push('/resposta/reencaminhar/' + id)
    },
    navigate (route) {
      this.$router.push(route)
    },
    voltar () {
      if (this.sistemaIntegracao && this.sistemaIntegracao.redirect_cadastro) {
        window.location.href = this.sistemaIntegracao.url_cliente
      }
      this.$router.push('/formularios')
    },
    exportarRespostas () {
      this.exportar = true
      if (this.validate()) {
        let dataInicio = this.filtros.dataInicio
        let dataFim = this.filtros.dataFim
        var id = this.$route.params.id
        window.location.href = process.env.ROOT_API1 + 'api/questionario/exportarRespostaInterno/' + id + '?dataInicio=' + dataInicio + '&dataFim=' + dataFim
      }
    },
    buscaUsuarioIntegracao () {
      let user_id = SessionStorage.get('usuario')
      Vue.http.get('api/usuario/' + user_id).then(response => {
        this.usuarioIntegracao = response.data.data[0]
        if (this.usuarioIntegracao.sistema_cliente_id) {
          Vue.http.get('api/sistema/' + this.usuarioIntegracao.sistema_cliente_id).then(response => {
            this.sistemaIntegracao = response.data.data[0]
          })
        }
      })
    },
    downloadArquivos (id) {
      let url = `${process.env.ROOT_API1}api/resposta-download-zip/${id}/${SessionStorage.get('token')}`
      window.open(url, '_blank').focus()
    },
    chkState (val) {
      const field = this.$v.filtros[val]
      if (!field.$model && !this.exportar) {
        return null
      }
      return !field.$dirty || !field.$invalid
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/cliente/questionarios/RespostasQuestionarios.vue